import { connect } from 'react-redux';
import uuid from 'uuid/v4';
import { configure } from '../actions';
import { DeviceContainer } from './container';
import { devicePropertiesSelector } from '../selectors/properties';

const mapStateToProps = (state, ownProps) => ({
  ID: devicePropertiesSelector(state, ownProps).ID || uuid(),
});

const mapDispatchToProps = (dispatch) => ({
  configure: (deviceData) => dispatch(configure(deviceData)),
});

export const ConnectedDevice = connect(mapStateToProps, mapDispatchToProps)(DeviceContainer);
